<script lang="ts">
  import { onMount} from "svelte";
  import {request} from './httphelper';
  export let error = null;
  let names : RatedName[] = [];

  let filters = [ "Alle", "Akzeptiert", "Abgelehnt", "1 Stern", "2 Sterne", "3 Sterne", "4 Sterne", "5 Sterne"];
  let activeFilter = 1;
  let rating = 0;
  let orders = ["A-Z", "Z-A", "Bewertung aufsteigend", "Bewertung absteigend"]
  let activeOrder = 0;
  $: count = names.length;
  $: countAccepted = names.reduce((total, item) => {
    return total + (Number(item.rating) > 0 ? 1 : 0);
    }, 0);
  $: countDismissed = count - countAccepted;
  $: namesToShow = (activeFilter, activeOrder, [...names].filter(filterNamesDismissed).sort(sortNames));

  onMount(async () => {
		const response = await request<RatedName[]>(new Request(`/evaluated_names.php`));
    if (!response.ok || response.apiResponseStatus != 0 || !response.parsedBody) {
      error = 'Fehler beim Abrufen der Namen ' + response.apiResponseStatus;
      return ;
    }
    else {
      names = response.parsedBody;
      }
    });

  function filterNamesDismissed(name : RatedName) {
    // index to filtersArray
    switch (activeFilter) {
      // "Akzeptiert"
      case 1:
        return Number(name.rating) > 0;
      // "Abgelehnt"
      case 2:
        return Number(name.rating) <= 0;
      // "1 Stern"
      case 3:
        return Number(name.rating) == 1;
      // "2 Sterne"
      case 4:
        return Number(name.rating) == 2;
      // "3 Stern"
      case 5:
        return Number(name.rating) == 3;
      // "4 Sterne"
      case 6:
        return Number(name.rating) == 4;
      // "5 Sterne"
      case 7:
        return Number(name.rating) == 5;
      default:
        return true;
      }
    }

  function cmpBestWorst(lhs : RatedName, rhs : RatedName) : number {
    if (lhs.rating > rhs.rating) return -1;
    if (lhs.rating < rhs.rating) return 1;
    return 0;
  }

  function cmpAZ(lhs : RatedName, rhs : RatedName) : number {
    if (lhs.name > rhs.name) return 1;
    if (lhs.name < rhs.name) return -1;
    return 0;
  }

  function sortNames(lhs : RatedName, rhs : RatedName) : number {
    switch(activeOrder) {
      case 1:
        return cmpAZ(lhs, rhs)*-1;
      case 2:
        return cmpBestWorst(lhs, rhs);
      case 3:
        return cmpBestWorst(lhs, rhs)*-1;
      default:
        return cmpAZ(lhs, rhs);
    }
  }

  function changeRating(e : Event) {
    let target = <HTMLInputElement> (e.currentTarget);
    propagateRating(Number(target.name), Number(target.value));
  }

  function onClickSwipe(id : number, rating : number) {
    propagateRating(id, rating);
  }

  function propagateRating(id : number, rating : number) {
    for (let i=0; i<names.length; i++) {
      if (names[i].id == id) {
        names[i].rating = rating;
        break;
      }
    }
    const response = request<any>(new Request(`/rate.php`,
          {
            method : 'POST',
            body:JSON.stringify({
              "nameid" : id,
              "rating" : rating,
            })
          }
          ));
  }

  interface RatedName {
    id : number,
    name : string,
    origin : string,
    meaning : string,
    rating : number
  }
</script>

<div class="flexcontainer">
  <div>Filter:<br>
    <select bind:value={activeFilter}>
      {#each filters as filter, index}
      <option value={index}>{filter}</option>
      {/each}
    </select>
  </div>
  <div>Sortierung:<br>
    <select bind:value={activeOrder}>
      {#each orders as order, index}
        {#if index <= 1 || activeFilter <= 1}
          <option value={index}>{order}</option>
        {/if}
      {/each}
    </select>
  </div>
</div>
<div>
  Bewertet: {count} Positiv: {countAccepted} Negativ: {countDismissed}
</div>
{#each namesToShow as currentName (currentName.id)}
<div class="name">
  <h4>{currentName.name}
    {#if currentName.rating > 0}<span class="arrow" style="color:red;" on:click={ () => onClickSwipe(currentName.id, 0)}>&larr;</span>
    {:else}<span class="arrow" style="color:green;" on:click={ () => onClickSwipe(currentName.id, 6)}>&rarr;</span>
    {/if}
  </h4>
  {#if currentName.rating > 0}
  <div>Bewertung:
    <label>
      <input type="radio" name={String(currentName.id)} value={1} bind:group={currentName.rating} on:change={changeRating}>
      1
    </label>
    <label>
      <input type="radio" name={String(currentName.id)} value={2} bind:group={currentName.rating} on:change={changeRating}>
      2
    </label>
    <label>
      <input type="radio" name={String(currentName.id)} value={3} bind:group={currentName.rating} on:change={changeRating}>
      3
    </label>
    <label>
      <input type="radio" name={String(currentName.id)} value={4} bind:group={currentName.rating} on:change={changeRating}>
      4
    </label>
    <label>
      <input type="radio" name={String(currentName.id)} value={5} bind:group={currentName.rating} on:change={changeRating}>
      5
    </label>
  </div>
  {/if}
</div>
{/each}

<style>
  h4 {
    margin: 2px;
  }
  .name {
    border: 1px solid black;
    margin-bottom: 5px;
    padding: 2px;
  }
  .flexcontainer {
    display: flex;
  }
  .flexcontainer div {
    margin: 5px 5px 5px 0;
  }
  .arrow {
    font-size: large;
    font-weight: bold;
  }
  input[type=radio], label {
    display: inline;
  }
</style>